// Centralized display label for the generic person/entity a call is about.
//
// User-facing UI should use these helpers instead of hard-coding "Patient",
// "Customer", "Lead", etc. The underlying API field names (e.g. `patient_name`)
// are intentionally left unchanged for backend compatibility — only the
// rendered label is governed here. Keeping this in one place means a future
// account setting could switch the term (Customer / Lead / Patient) without
// touching every component.

export const ENTITY_LABEL = "Contact";

// Fallback shown when a call/appointment has no associated name.
export const UNKNOWN_ENTITY_LABEL = `Unknown ${ENTITY_LABEL}`; // "Unknown Contact"

export function entityLabel() {
  return ENTITY_LABEL;
}

// Returns a trimmed display name, or the generic fallback when empty.
export function contactName(name, fallback = UNKNOWN_ENTITY_LABEL) {
  const trimmed = String(name ?? "").trim();
  return trimmed || fallback;
}
